import LoadsService from '../providers/Loads/Loads.service';
import { MIN_STOP_COUNT } from '../redux/features/orders/ordersSlice';
import { useAppSelector } from '../redux/hooks';
import NumberUtils from '../utils/numberUtils';

interface UseCalculateLoadedMiles {
  calculateTotalLoadedMiles: () => Promise<number>;
}

const useCalculateLoadedMiles = (): UseCalculateLoadedMiles => {
  const orders = useAppSelector((state) => state.orders);

  const calculateTotalLoadedMiles = async (): Promise<number> => {
    const stops = [...orders.provider_stops];

    if (stops.length < MIN_STOP_COUNT) return 0;

    const firstStop = stops.shift();
    const lastStop = stops.pop();

    const firstStopId = firstStop?.provider_location?.id;
    const lastStopId = lastStop?.provider_location?.id;

    if (firstStopId && lastStopId) {
      const intermediateStopsIds: string[] = [];
      stops.map((stop) => {
        if (stop.provider_location?.id) {
          intermediateStopsIds.push(stop.provider_location?.id);
        }
      });

      try {
        const response = await LoadsService.getEstimatedMilage(
          firstStopId,
          lastStopId,
          intermediateStopsIds
        );

        return NumberUtils.roundNumber(Number(response.milage), 2);
      } catch (error) {
        console.error(error);
        return 0;
      }
    }

    return 0;
  };

  return {
    calculateTotalLoadedMiles
  };
};

export default useCalculateLoadedMiles;
